import type { EmojiDetails } from '@lumapps/pickers/types';
import type { InlineAutocompleteOptions } from '@lumapps/wrex-inline-autocomplete/types';
import { isHeading } from '@lumapps/wrex-typography/utils/isHeading';
import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';
import type { Text } from '@lumapps/wrex/slate';
import { Wrex } from '@lumapps/wrex/types';

import { useSearchEmojiData } from './hooks/useSearchEmojiData';

/** Emoji inline autocomplete option to pass to the withInlineAutocomplete plugin */
export const emojiAutocompleteOption = {
    triggerCharacter: ':',
    isElementAllowed: (element?: Wrex.Element) => isParagraph(element) || isHeading(element),
    elementCreator: (emojiObject: EmojiDetails['emoji']) => ({ text: emojiObject.unicode }),
    getEntityId: (emoji: EmojiDetails['emoji']) => emoji?.shortcodes?.[0],
    getEntityLabel: (emoji: EmojiDetails['emoji']) => emoji?.shortcodes?.[0],
    getListItemProps: (emojiObject: EmojiDetails['emoji']) => ({
        before: emojiObject?.unicode,
    }),
    fetchHook: useSearchEmojiData,
} as InlineAutocompleteOptions<Text, EmojiDetails['emoji']>;
